import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Machine } from 'src/models/machine/machine';
import { environment } from 'src/environments/environment.prod';

const SERVICE_NAME =  environment.SERVICE_NAME;

@Injectable({
  providedIn: 'root'
})

export class MachineService {

  constructor(private http: HttpClient) {
  }


  getMachine(pagination?: any): Observable<Machine> {
    return this.http.post<any>(SERVICE_NAME + 'listMachines', pagination);
  }

  getMachineMaster(): Observable<Machine[]> {
    return this.http.get<any>(SERVICE_NAME + 'listMachineMaster');
  }

  createMachine(machine?: any): Observable<Machine> {
    return this.http.post<any>(SERVICE_NAME + 'createMachine', machine);
  }

  viewMachine(machineId?: string): Observable<Machine> {
    return this.http.post<any>(SERVICE_NAME + 'getMachineById', machineId);
  }

  updateMachine(machine?: any): Observable<Machine> {
    return this.http.put<any>(SERVICE_NAME + 'updateMachine', machine);
  }

  updateMachineOrders(machine?: any): Observable<Machine[]> {
    return this.http.put<any>(SERVICE_NAME + 'updateMachineOrders', machine);
  }

  getEmployeeShiftByMachineId(machine?: any): Observable<Machine[]> {
    return this.http.post<any>(SERVICE_NAME + 'getEmployeeShiftByMachineId', machine);
  }
  
  deleteMachine(machine?: any): Observable<Machine> {
    return this.http.post<any>(SERVICE_NAME + 'deleteMachine', { id: machine });
  }

  updateAlert(alertMessage?: any): Observable<Machine> {
    return this.http.put<any>(SERVICE_NAME + 'updateAlert', alertMessage);
  }

}
